import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const sortAndFilterContainerStyles = css`
  @media ${BREAKPOINT_QUERIES.Mobile} {
    > * {
      flex-shrink: 0;
    }

    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    overflow-x: auto;
  }
`;
